import React, { PureComponent } from 'react'
import ModuleContainer from '../../components/ModuleContainer';
import ViewHeader from '../../components/ViewHeader';
import {
    MODE_EDIT, MODE_VIEW, SUCCESS, NOTIF_ERROR, NOTIF_SUCCESS, NOTIF_WARNING, CHECKED, UNCHECKED, PAGINATION_NUMBER, USER_MANAGEMENT,
    ADD_MEMBER, SUCCESS_BUTTON, MEMBERS, EXPORT_DATA, LINK, BLACK, BLUE, RED, NO, SECONDARY, YES, DANGER
} from '../../../utils/constants';
import { ADD_MEMBER_ROUTE, VIEW_MEMBER_ROUTE } from './routes';
import { Link } from 'react-router-dom';
import { FaPlus, FaEye, FaTrashAlt, FaEdit, FaDownload } from 'react-icons/fa';
import TableTemplate from '../../components/TableTemplate';
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux';
import { Row, Col, Button } from 'react-bootstrap';
import { memberOperations } from './state';
import Pagination from '../../components/PaginationTemplate';
import { PRIMARY_USER_ALREADY_EXISTS, MSG_EXPORT, MSG_DEFAULT_ERROR, MSG_REMOVE, DELETE_MEMBER, DELETE_MESSAGE } from '../../../utils/messages';
import { SideNotification } from '../../../utils/common';
import ConfirmationModal from '../../components/ConfirmationModal';
import { isNullOrUndefined } from '../../../../node_modules/util';
import VideoMenu from '../../../includes/img/svg/movie-videos.svg';
import { VIDEO_ROUTE } from './../../../utils/constants';
import debounce from 'lodash.debounce'


class Members extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            showDeleteModal: false,
            modalId: 0,
            search: '',
            pageNumber: 1,
            activePage: 1,
            totalPages: 0,
            memberList: [],
            isPrimaryUser: 0,
            subscribedMembers: 0,
            totalMembers: 0,
            unsubscribedMembers: 0,
            currentUserId: 0,
            accessRights: 0
        }
        this.retrieveList = debounce(this.retrieveList.bind(this), 500);
        this.deleteRow = debounce(this.deleteRow.bind(this), 500);
        this.export = debounce(this.export.bind(this), 500);
    }

    componentDidMount() {

        this.retrieveList();

        let id = this.props.currentUser.credentials.userId
        let userAccessRights = this.props.currentUser.credentials.accessRights;

        this.setState({
            currentUserId: id,
            accessRights: userAccessRights
        })
    }

    retrieveList = () => {
        let data = {
            "pageNumber": this.state.activePage,
            "searchPollField": this.state.search
        }
        this.props.getMemberList(data)
            .then((result) => {
                if (undefined !== result) {
                    if (SUCCESS === result.status) {
                        let member = result.data.memberList
                        let memberDetails = result.data.memberListDetails
                        this.setState({
                            memberList: member.list,
                            totalPages: member.totalPage,
                            unsubscribedMembers: memberDetails.numberOfUnsubscribedMembers,
                            totalMembers: memberDetails.numberOfMembers,
                            subscribedMembers: memberDetails.numberOfSubscribedMembers,
                            activePage: member.pageNumber
                        });
                    }
                }
            }).catch(() => {
                SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR);
            })

    }


    viewMember = (data, type) => {
        let params = {};
        if (MODE_EDIT === type || MODE_VIEW === type) {
            params.data = data;
            params.type = type;
            this.props.history.push({
                pathname: VIEW_MEMBER_ROUTE + `/${data.userId}`,
                state: params
            })
        }
        else {
            this.props.history.push(ADD_MEMBER_ROUTE);
        }
    }

    handleCheckboxChanges = (event, index) => {

        let tempMemberList = Object.assign([], this.state.memberList)

        let isChecked = event.target.checked ? CHECKED : UNCHECKED

        if (undefined !== tempMemberList[index]) {
            this.props.updateMemberPrimaryUser(tempMemberList[index].userId)
                .then((result) => {
                    if (undefined !== result && SUCCESS === result.status) {
                        if (result.data) {
                            SideNotification(NOTIF_ERROR, PRIMARY_USER_ALREADY_EXISTS);
                        }
                        else {
                            tempMemberList[index].isPrimaryUser = isChecked
                            this.setState({
                                memberList: tempMemberList
                            })
                            SideNotification(NOTIF_SUCCESS, result.message);
                        }
                    } else {
                        SideNotification(NOTIF_ERROR, result.message);
                    }
                })
        }


    }

    handleSearchChange = (event) => {
        this.setState({ search: event.target.value }, () => this.retrieveList());
    }

    handlePageClick = (pageNumber) => {
        this.setState({ activePage: pageNumber, memberList: [] }, () => this.retrieveList());
    }

    handlePagePrev = () => {
        this.setState({ activePage: this.state.activePage - PAGINATION_NUMBER, memberList: [] }, () => this.retrieveList());
    }

    handlePageNext = () => {
        this.setState({ activePage: this.state.activePage + PAGINATION_NUMBER, memberList: [] }, () => this.retrieveList());
    }

    handlePageFirst = () => {
        this.setState({ activePage: PAGINATION_NUMBER , memberList: []}, () => this.retrieveList());
    }

    handlePageLast = () => {
        this.setState({ activePage: this.state.totalPages, memberList: [] }, () => this.retrieveList());
    }
    handleSearchChange = (event) => {
        this.setState({ search: event.target.value, activePage: 1 }, () => this.retrieveList());
    }

    export = () => {
        this.props.exportMembers()
            .then((result) => {
                if (undefined !== result && 200 === result.status) {
                    SideNotification(NOTIF_SUCCESS, MSG_EXPORT);
                } else {
                    SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR);
                }
            });
    }

    toggleDelete = (row) => {
        
        if (!isNullOrUndefined(row) && this.state.currentUserId === row.userId) {
            SideNotification(NOTIF_WARNING, MSG_REMOVE);
        }
        else {
            this.setState(prevState => ({ showDeleteModal: !prevState.showDeleteModal, modalId: isNullOrUndefined(row) ? null : row.userId }))
        }
    }

    deleteRow = () => {
        this.props.deleteMember(this.state.modalId)
            .then((result) => {
                if (SUCCESS === result.status) {
                    SideNotification(NOTIF_SUCCESS, result.message);
                    this.retrieveList();
                } else {
                    SideNotification(NOTIF_ERROR, result.message);
                }
                this.toggleDelete();
            });
    }

    render() {
        if (this.state.accessRights === 3) {
            return (
                <ModuleContainer>
                    User does not have the right access for this screen. Here is a list of screens that you can access:
                    <Link className='sideNavAnchor' key={VIDEO_ROUTE} href={VIDEO_ROUTE} to={VIDEO_ROUTE}>
                        <li className='sideNavList'>
                            <img src={VideoMenu} className="menu-icon" alt="menu-icon"/>
                            SHAABAA Game Videos
                        </li>
                    </Link>
                </ModuleContainer >
            )
        } else {
        return (
            <ModuleContainer>
                <ViewHeader
                    withSearch={true}
                    title={USER_MANAGEMENT}
                    onSearchChange={this.handleSearchChange}
                    rightButtons={[
                        { variant: SUCCESS_BUTTON, label: ADD_MEMBER, icon: FaPlus, onClick: this.viewMember }
                    ]}
                />
                <Row className="row-members">
                    <Col md={2} className={MEMBERS}>Total Members: {this.state.totalMembers}</Col>
                    <Col md={2} className={MEMBERS}>Subscribed Members:  {this.state.subscribedMembers}</Col>
                    <Col md={3} className={MEMBERS}>Unsubscribed Members:  {this.state.unsubscribedMembers}</Col>
                    <Col md={5} className={MEMBERS}>
                        <Button  className="export-button" onClick={() => this.export()}><FaDownload />{EXPORT_DATA}</Button>
                    </Col>
                </Row>
                <TableTemplate
                    handleCheckboxChanges={this.handleCheckboxChanges}
                    tableHeader={this.props.memberTableHeaders}
                    tableColumns={this.props.memberTableColumns}
                    tableList={this.state.memberList}
                    activePage={this.state.activePage}
                    rowButtons={[
                        { variant: LINK, icon: FaEye, color: BLACK, onClick: this.viewMember, type: MODE_VIEW },
                        { variant: LINK, icon: FaEdit, color: BLUE, onClick: this.viewMember, type: MODE_EDIT },
                        { variant: LINK, icon: FaTrashAlt, color: RED, onClick: this.toggleDelete }
                    ]}
                />

                <ConfirmationModal
                    show={this.state.showDeleteModal}
                    toggleModal={this.toggleDelete}
                    title={DELETE_MEMBER}
                    message={DELETE_MESSAGE}
                    modalButtons={[
                        { label: NO, onClick: this.toggleDelete, variant: SECONDARY },
                        { label: YES, onClick: this.deleteRow, variant: DANGER }
                    ]}
                />

                <Pagination
                    {...this.state}
                    handlePageClick={this.handlePageClick}
                    handlePagePrev={this.handlePagePrev}
                    handlePageNext={this.handlePageNext}
                    handlePageLast={this.handlePageLast}
                    handlePageFirst={this.handlePageFirst}
                />

            </ModuleContainer >
        )
    }
    }

}

const mapStateToProps = (state) => {
    return {
        memberList: state.members.memberList,
        memberTableHeaders: state.members.memberTable.tableHeaders,
        memberTableColumns: state.members.memberTable.tableColumns,
        currentUser: state.auth,
    }
}

const mapDispatchToProps = (dispatch) => bindActionCreators(
    {
        //operations here
        getMemberList: memberOperations.getMemberList,
        updateMemberPrimaryUser: memberOperations.updateMemberPrimaryUser,
        deleteMember: memberOperations.deleteMember,
        exportMembers: memberOperations.exportMembers
    },
    dispatch
)

export default connect(mapStateToProps, mapDispatchToProps)(Members);
